<template>
  <div class="container" v-if="applicationDataLoaded">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h4 class="title is-4">
            {{ application.organization.name }}
            <span
              class="tag is-primary"
              v-if="application.isEvaluatedByUser"
              style="margin: 0 10px"
            >
              Completed
            </span>
          </h4>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <router-link
            :to="{
              name: 'StaffApplicationReviewDetail',
              params: { applicationId: application.id },
            }"
          >
            <button class="button">
              Return to Proposal
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <h4 class="title is-4">Their Submitted Proposal</h4>
        <div class="content">
          <table class="table is-bordered propTable">
            <tbody>
              <tr>
                <th class="app-summary-label">Submission Sort Name</th>
                <td class="has-text-centered">{{ application.sortName }}</td>
              </tr>
              <tr>
                <th>Organization Name</th>
                <td class="has-text-centered">{{ application.organization.name }}</td>
              </tr>
              <tr>
                <th>Organization Type</th>
                <td class="has-text-centered">{{ application.questionOrganizationType }}</td>
              </tr>
              <tr>
                <th>Organization Website</th>
                <td class="has-text-centered">{{ application.questionOrganizationWebsite }}</td>
              </tr>
              <tr>
                <th>Applicant Name</th>
                <td class="has-text-centered">{{ application.submitter.fullName }}</td>
              </tr>
              <tr>
                <th>Applicant Emails</th>
                <td class="has-text-centered">{{ application.submitter.oldNotes }}</td>
              </tr>
            </tbody>
          </table>
          <span v-if="application.questionTellUsAboutYourOrganization.length > 0" >
          <h5 class="title is-5">Tell us about your organization</h5>
          <p class="content">{{ application.questionTellUsAboutYourOrganization }}</p>
          </span>
         
          <span v-if="application.questionWhichTypeOfFunding.length > 0" >
          <h5 class="title is-5">Which type of funding do you think is the best fit for the appeal made in this proposal?</h5>
          <p class="content">{{ application.questionWhichTypeOfFunding }}</p>
          </span>
         
          <span v-if="application.questionTellUsAboutProposal.length > 0" >
          <h5 class="title is-5">Tell us about your proposal</h5>
          <p  class="content">{{ application.questionTellUsAboutProposal }}</p>
          </span>
         
          <span v-if="application.questionChangesToApproach.length > 0" >
          <h5 class="title is-5">Have there been major changes to the way you approach funders and/or write proposals since your last submission?</h5>
          <p class="content">{{ application.questionChangesToApproach }}</p>
          </span>
         
          <span v-if="application.questionWhereElseHaveYouSubmitted.length > 0" >
          <h5 class="title is-5">Where else have you submitted this? Or where do you plan to submit?</h5>
          <p class="content">{{ application.questionWhereElseHaveYouSubmitted }}</p>
          </span>
         
          <span v-if="application.questionWhyRejected.length > 0" >
          <h5 class="title is-5">If they said no, why do you think it was rejected?</h5>
          <p class="content">{{ application.questionWhyRejected }}</p>
          </span>
         
          <span v-if="application.questionAdditionalComments.length > 0" >
          <h5 class="title is-5">Any additional comments?</h5>
          <p class="content">{{ application.questionAdditionalComments }}</p>
          </span>
         
          <h5 class="title is-5">Provide us a link to your application</h5>
          <p class="content">
            <a :href="application.proposal" target="_blank">
              <button class="button">Download Proposal</button>
            </a>
          </p>
        </div>
      </div>
      <div class="column">
        <h5 class="title is-4">Your Edits</h5>
        <div class="field">
          <div class="control">
            <label class="label">Submission Name</label>
            <input type="text" class="input" v-model="editedApplication.name" />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <label class="label">Submission Sort Name</label>
            <input type="text" class="input" v-model="editedApplication.sortName" />
          </div>
        </div>
        <div class="field">
          <button class="button" @click="updateData">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Application from '@/services/applications/'

export default {
  data() {
    return {
      applicationId: null,
      applicationDataLoaded: false,
      application: null,
      editedApplication: null,
    }
  },
  created() {
    this.applicationId = this.$route.params.applicationId
    this.refreshData()
  },
  methods: {
    refreshData() {
      Application.api.get(this.applicationId).then(data => {
        this.application = data
        this.editedApplication = this.application.copy()
        this.applicationDataLoaded = true
      })
    },
    updateData() {
      let fields = ['name', 'sortName']
      Application.api.update(this.editedApplication, fields).then(data => {
        this.application = data
      })
    },
  },
}
</script>

<style scoped>
.tag {
  margin: 0 2px;
}
.fa {
  margin: 0 2px;
}
.propTable {
  word-break: break-word;
}
.app-summary-label {
  min-width: 130px;
}
</style>
